/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ObjectImportTask } from "./ObjectImportTask";
import {
  ObjectImportTaskFromJSON,
  ObjectImportTaskFromJSONTyped,
  ObjectImportTaskToJSON,
  ObjectImportTaskToJSONTyped,
} from "./ObjectImportTask";

/**
 *
 * @export
 * @interface ApiObjectimporttasksList200Response
 */
export interface ApiObjectimporttasksList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiObjectimporttasksList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiObjectimporttasksList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiObjectimporttasksList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ObjectImportTask>}
   * @memberof ApiObjectimporttasksList200Response
   */
  results: Array<ObjectImportTask>;
}

/**
 * Check if a given object implements the ApiObjectimporttasksList200Response interface.
 */
export function instanceOfApiObjectimporttasksList200Response(
  value: object
): value is ApiObjectimporttasksList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiObjectimporttasksList200ResponseFromJSON(
  json: any
): ApiObjectimporttasksList200Response {
  return ApiObjectimporttasksList200ResponseFromJSONTyped(json, false);
}

export function ApiObjectimporttasksList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiObjectimporttasksList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(ObjectImportTaskFromJSON),
  };
}

export function ApiObjectimporttasksList200ResponseToJSON(
  json: any
): ApiObjectimporttasksList200Response {
  return ApiObjectimporttasksList200ResponseToJSONTyped(json, false);
}

export function ApiObjectimporttasksList200ResponseToJSONTyped(
  value?: ApiObjectimporttasksList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(ObjectImportTaskToJSON),
  };
}
